<template>
  <div class="px">
    <!-- Loading -->
    <div
      class="d-flex justify-content-center w-100"
      style="margin-top: 110px"
      v-if="loadingTable">
      <loading />
    </div>
    <!-- DataTable -->
    <div v-else>
      <planificacion-semanal-tabla />
    </div>
  </div>
</template>

<script>
// Vuex
import { mapActions, mapState } from "vuex";
//
import Loading from "../../components/common/loading.vue";
import PlanificacionSemanalTabla from "@/components/tablas/charter/PlanificacionSemanalTabla.vue";

export default {
  components: { PlanificacionSemanalTabla, Loading },
  computed: {
    ...mapState(["loadingTable"]),
  },
  methods: {
    // Acciones de Vuex
    ...mapActions(["AccionCambiar"]),

    // Función para actualizar url en state

    actualizarURL() {
      let me = this;
      me.AccionCambiar(this.$route.path);
    },
  },
  created() {
    // Ejecución de actualizarURL una vez que se carga el componente
    this.actualizarURL();
  },
};
</script>

<style></style>
